export interface Token {
    account_id: string;
    /** Active workspace after switch-account; falls back to account_id when unset. */
    active_account_id?: string | null;
    entity_type: string;
    entity_id: string;
    context: {
        entity_type: string;
        entity_id: string;
    } | null;
    identity_provider?: string | null;
    jwt_token: string;
    refresh_token: string;
    token_expire_time?: string | null;
}

/** Workspace account currently active on the token (switched account, or login account). */
export const getTokenActiveAccountId = (token: Pick<Token, 'account_id' | 'active_account_id'>): string => token.active_account_id ?? token.account_id;

export interface IoTProvision {
    identifier: string;
    type: string;
    brand: string;
}

export interface AuthenticationErrorResponse {
    ctx: { [key: string]: string };
    input: string;
    loc: string[];
    msg: string;
    type: string;
}

export class AuthenticationError extends Error {
    detail: string | AuthenticationErrorResponse[];

    constructor(message: string, response: { detail: string | AuthenticationErrorResponse[] }) {
        super(message);
        this.detail = response.detail;
    }
}
